/** LaunchDarkly flag key (dashboard). */
export const LAUNCHDARKLY_FLAG_KEYS = {
  /**
   * Slice 11 kill switch for the live credential flow (AES-387).
   * AES-388 uses it for the live approve modal.
   * OFF / unavailable keeps today's approve dialog (fail-closed).
   * Local (LD disabled) defaults to ON.
   */
  liveCredentials: "api-portal-live-credentials",
  /**
   * Kill switch for imported sandbox credentials without a test location
   * (AES-406). OFF / unavailable requires a ready location again and restores
   * the create-a-location copy. Local (LD disabled) defaults to ON.
   */
  importedSandboxCredentials: "api-portal-imported-sandbox-credentials",
  /**
   * Kill switch for the imported live credentials support notice (AES-402).
   * OFF / unavailable hides the notice (fail-closed).
   * Local (LD disabled) defaults to ON.
   */
  importedCredentialsSupport: "api-portal-imported-credentials-support",
  /**
   * Slice 12 gate for reading integrator access scope from Glofox (AES-412).
   * The LaunchDarkly key is lowercase with dashes.
   * OFF / unavailable keeps today's sandbox and live behavior.
   * No screen reads this flag yet. The API evaluates it.
   */
  integratorAccessScope: "api-portal-integrator-access-scope",
} as const;

/** camelCase key returned by `useFlags()` for `api-portal-live-credentials`. */
export const LD_LIVE_CREDENTIALS_FLAG = "apiPortalLiveCredentials" as const;

/** camelCase key returned by `useFlags()` for `api-portal-imported-sandbox-credentials`. */
export const LD_IMPORTED_SANDBOX_CREDENTIALS_FLAG =
  "apiPortalImportedSandboxCredentials" as const;

/** camelCase key returned by `useFlags()` for `api-portal-imported-credentials-support`. */
export const LD_IMPORTED_CREDENTIALS_SUPPORT_FLAG =
  "apiPortalImportedCredentialsSupport" as const;

/**
 * camelCase spelling `useFlags()` returns for `api-portal-integrator-access-scope`.
 * This is the same LaunchDarkly flag, not a second key.
 */
export const LD_INTEGRATOR_ACCESS_SCOPE_FLAG =
  "apiPortalIntegratorAccessScope" as const;
